export class DpiDTO {
  categoriaAttrezzaturaId: number;
}
